<template>
  <div
    v-if="isLoading"
    class="loading-container"
  >
    <img
      :src="loadinglogo"
      :alt="content.loadingAlt"
      class="loading-logo"
    >
  </div>
  <div v-else>
    <label class="invite-language-picker">
      <span class="invite-sr-only">{{ content.languageLabel }}</span>
      <select
        :value="locale"
        :aria-label="content.languageLabel"
        @change="changeLocale"
      >
        <option
          v-for="option in localeOptions"
          :key="option.code"
          :value="option.code"
        >
          {{ option.name }}
        </option>
      </select>
    </label>
    <div class="landing-container">
      <header class="header">
        <img
          :src="appIcon"
          :alt="content.brand"
          class="app-icon"
        >
        <h1 class="app-title">
          {{ content.brand }}
        </h1>
      </header>

      <h2 class="headline">
        {{ content.headline }}
      </h2>

      <img
        :src="landingPhones"
        :alt="content.screensAlt"
        class="phone-mockup"
      >

      <p class="features-text">
        {{ content.description }}
      </p>

      <div class="cta-container">
        <a
          href="https://apps.apple.com/app/id6742995719"
          target="_blank"
          rel="noopener noreferrer"
          class="store-button"
        >
          <img
            :src="appleLogo"
            :alt="content.appleName"
            class="store-logo"
          >
          <div class="button-text-wrapper">
            <span class="button-text-line1">{{ content.applePrefix }}</span>
            <span class="button-text-line2">{{ content.appleName }}</span>
          </div>
        </a>

        <a
          href="https://play.google.com/store/apps/details?id=happy.pet.com.ai"
          target="_blank"
          rel="noopener noreferrer"
          class="store-button"
        >
          <img
            :src="googlePlayLogo"
            :alt="content.googleName"
            class="store-logo"
          >
          <div class="button-text-wrapper">
            <span class="button-text-line1">{{ content.googlePrefix }}</span>
            <span class="button-text-line2">{{ content.googleName }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import appIcon from '../assets/app-icon.png';
import landingPhones from '../assets/landing-phones.png';
import appleLogo from '../assets/apple-logo.png';
import googlePlayLogo from '../assets/gp-logo.png';
import loadinglogo from '../assets/loading-logo.png';
import { buildInviteContent } from '../content/inviteContent.mjs'
import { useLocale } from '../i18n/useLocale'
import { applyRouteSeo } from '../utils/seo'

defineProps({
  code: { type: String, default: '' },
  msg: { type: String, default: '' }
})

const isLoading = ref(false);
const route = useRoute()
const { locale, localeOptions, setLocale } = useLocale()
const content = computed(() => buildInviteContent(locale.value))
const changeLocale = (event) => setLocale(event.target.value)

watch(locale, (nextLocale) => {
  applyRouteSeo(route, nextLocale)
}, { immediate: true })

onMounted(() => {
  // setTimeout(() => {
  //   isLoading.value = false;
  // }, 2000);

  const schemeUrl = 'happypet://www.starapp.fun' + window.location.pathname + window.location.search;

  // 创建一个临时 iframe 来尝试唤起 App（不会影响主页面）
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = schemeUrl;
  document.body.appendChild(iframe);

  // 2 秒后移除 iframe
  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 2000);
  
})
</script>

<style>
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-image: url("@/assets/bg.png");
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  color: #fff;
}

.invite-language-picker {
  position: fixed;
  top: 18px;
  right: 18px;
  z-index: 10;
}

.invite-language-picker select {
  max-width: 160px;
  padding: 9px 30px 9px 12px;
  color: #243047;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 999px;
  font: inherit;
  font-size: 14px;
}

.invite-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-image: url("@/assets/loading-bg.png");
  background-size: cover;
  z-index: 999;
}

.loading-logo {
  width: 112px;
  animation: pulse 2s infinite ease-in-out;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 0.9; }
  50% { transform: scale(1.05); opacity: 1; }
}

.landing-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 40px 20px;
  text-align: center;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.app-icon {
  width: 60px;
  height: 60px;
  margin-right: 15px;
  border-radius: 12px;
}

.app-title {
  font-size: 2.2rem;
  font-weight: 600;
  color: #fff;
}

.headline {
  font-size: 1.6rem;
  font-weight: 600;
  max-width: 500px;
  margin-bottom: 40px;
}

.phone-mockup {
  width: 328px;
  height: auto;
  margin-bottom: 40px;
}

.features-text {
  font-size: 1.1rem;
  max-width: 420px;
  margin-bottom: 30px;
}

.cta-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 320px;
  align-items: center;
}

.store-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 200px;
  background-image: url("@/assets/btn.png");
  background-size: 100% 100%;
  border-radius: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
  text-decoration: none;
}

.store-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.store-logo {
  height: 28px;
  margin-right: 10px;
}

.button-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1;
  color: #fff ;
}

.button-text-line1 {
  font-size: 0.8rem;
}

.button-text-line2 {
  font-size: 1.2rem;
  font-weight: 600;
}
</style>
